<!-- MAIN Template - End -->
<ng-container *ngIf="showMainTemplates && templateMainBegin">
  <ng-container *ngTemplateOutlet="templateMainBegin.templateRef"></ng-container>
</ng-container>

<ng-container
  *ngIf="importObjectContextDto && importObjectContextDto.entries && importObjectContextDto.entries.length>0">
  <p-chip
    *ngFor="let entry of importObjectContextDto.entries"
    label="{{entry.objectTypeAlias}} ({{entry.id}})"
    [removable]="true"
    (onRemove)="removeImportObjectContextEntry(entry)"></p-chip>
</ng-container>

<div *ngIf="actionCreateShow">

  <div *ngIf="showActionBar" class="surface-section px-4 py-2 lg:pl-5 lg:pr-4 -mx-5 -mt-5 mb-5 shadow-b-2">
    <div class="flex align-items-center justify-content-between flex-row pb-2 surface-border">
      <div class="flex align-items-center">
        <i class="pi pi-globe text-2xl mr-3 text-500"></i>
        <span class="text-3xl font-medium text-900">[Reflected-Object]</span>
      </div>
      <div class="mt-0">
        <p-popover #opCreateActions>
            <p-menu [model]="actionCreateMenu"></p-menu>
        </p-popover>

        <button type="button" pButton pRipple icon="fa-regular fa-plus"
                (click)="opCreateActions.toggle($event)"></button>
      </div>
    </div>
  </div>

  <div *ngIf="!showActionBar" class="">
    <div class="my-3">
      <p-popover #opCreateActions>
          <p-menu [model]="actionCreateMenu"></p-menu>
      </p-popover>

      <button type="button" class="p-button-raised p-button-rounded w-2rem h-2rem" pButton pRipple
              icon="fa-regular fa-plus" (click)="opCreateActions.toggle($event)"></button>
    </div>
  </div>

</div>

<ng-container *ngIf="showCardEntries">

  <div class="grid" *ngIf="objectStructureResult && objectStructureResult.root">

    <!-- MAIN NAVIGATION -->
    <div class="col-12 lg:col-3" *ngIf="showNavigation && mode != 'root.cards'">
      <mvs-object-navigation-menu></mvs-object-navigation-menu>
    </div>

    <!-- SUB STRUCTURE -->
    <div class="col-12 lg:col-3" *ngIf="uiMainObjectAliasStructureTreeVisible">
      <p-tree selectionMode="single"
              (onNodeSelect)="onObjectStructureSubNodeSelect($event)"
              [value]="mainObjectStructureResult.root.children"
              [(selection)]="mainObjectSubObjectSelected"
              [filter]="true"
              filterMode="strict"
              scrollHeight="500px">
      </p-tree>
    </div>

    <div class="col-12" *ngIf="mode == 'root.cards'">
      <div class="">
        <div class="grid">
          <div class="col-12 lg:col-4" *ngFor="let cardEntry of cardEntries">
            <p-card (click)="changeNavigationEntry(cardEntry.entry)"
                    styleClass="cursor-pointer fadeinright animation-linear animation-duration-300">
              <ng-template pTemplate="header">
                <div class="p-4">
                  <div class="flex align-items-center">
                                        <span
                                          class="inline-flex border-circle align-items-center justify-content-center bg-primary mr-3">
                                            <i class="pi pi-list text-xl p-2" *ngIf="!cardEntry.image"></i>
                                            <mvs-icon
                                              *ngIf="cardEntry.image"
                                              class="text-xl p-2"
                                              [icon]="cardEntry.image"
                                            ></mvs-icon>
                                        </span>
                    <span class="text-900 font-medium text-xl">{{ cardEntry.header }}</span>
                  </div>
                </div>
              </ng-template>
              <ng-template pTemplate="content">
                <p class="text-600 line-height-2 -mt-4 " *ngIf="cardEntry.description">
                  {{ cardEntry.description }}
                </p>
              </ng-template>
            </p-card>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="mode == 'entity.table'" class="col-12" [ngClass]="{'lg:col-9' : showNavigation}">

      <!-- SHOW AREA 1 and 2 CRUD Components-->
      <!--            <mvs-widget-->
      <!--                    *ngIf="widgetEntityTable"-->
      <!--                    [widgetData]="widgetEntityTable"-->
      <!--                    (onObjectSelect)="onObjectSelectWidgetTable($event)"-->
      <!--            ></mvs-widget>-->

      <ng-container #pageWidgetContainer></ng-container>

    </div>

    <!--    DISPLAY OR CHANGE CRUD OBJECT -->
    <div *ngIf="mode == 'entity.crud.object'"
         class="{{(uiMainObjectAliasStructureTreeVisible) ? 'col-9' : 'col-12' }} py-0"
         [ngClass]="{'lg:col-9' : showNavigation}">

      <!--
      <p-panel styleClass="max-width:500px">
          <mvs-crud-object
                  *ngIf="crudObjectShow"
                  [objectType]="crudObjectType"
                  [objectId]="crudObjectId"
                  [importObjectContextDto]="crudObjectImportObjectContext"
                  (onChangedObject)="onObjectChanged($event)"
          ></mvs-crud-object>
      </p-panel>
      -->

      <mvs-object
        *ngIf="crudObjectShow && !useOnlyRegularCrudComponent"
        [importObjectContext]="crudObjectImportObjectContext"
        [objectType]="crudObjectType"
        [objectId]="crudObjectId"
      ></mvs-object>

      <mvs-crud-object
        *ngIf="crudObjectShow && useOnlyRegularCrudComponent"
        [objectType]="crudObjectType"
        [objectId]="crudObjectId"
        [importObjectContextDto]="crudObjectImportObjectContext"
        (onChangedObject)="onObjectChanged($event)"
      ></mvs-crud-object>


    </div>

    <!--    CREATE CRUD OBJECT -->
    <div *ngIf="mode == 'entity.crud.object.create'"
         class="{{(uiMainObjectAliasStructureTreeVisible) ? 'col-9' : 'col-12' }}"
         [ngClass]="{'lg:col-9' : showNavigation}">

      <p-panel class="max-width:500px" header="Create new record">
        <mvs-crud-object
          *ngIf="crudObjectShow"
          [objectType]="crudObjectType"
          [objectId]="crudObjectId"
          [importObjectContextDto]="crudObjectImportObjectContext"
          (onChangedObject)="onObjectChanged($event)"
        ></mvs-crud-object>
      </p-panel>
    </div>
  </div>

</ng-container>

<!-- MAIN Template - End -->
<ng-container *ngIf="showMainTemplates && templateMainEnd">
  <ng-container *ngTemplateOutlet="templateMainEnd.templateRef"></ng-container>
</ng-container>

